import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

import {
  applicationDocsKey,
  formGetDocumentRoute,
} from '@features/applicationsDocs';
import axiosInstance from '@server/axiosInstance';

type UseGetApplicationDocsProps = {
  applicationId: number;
  enabled: boolean;
};

export const useGetApplicationDocs = ({
  applicationId,
  enabled,
}: UseGetApplicationDocsProps) => {
  const { data: applicationDocsData } = useQuery({
    queryKey: [applicationDocsKey, applicationId],
    queryFn: () =>
      axiosInstance
        .get(formGetDocumentRoute(applicationId))
        .then((res) => res.data),
    enabled,
    refetchOnWindowFocus: false,
  });
  return { applicationDocsData };
};
